import * as React from 'react';
import EventService from '../CalculationComponents/calculationComponents.eventservice';
import { SEND, POST_ERROR } from '../StatsbidragSubmitAction/StatsbidragSubmitAction';
import ValidationService from '../../services/validation.service';
import { Dialog } from 'sos-common/js/components/Dialog/Dialog';
import { Icon } from 'sos-common/js/components/Icon/icon';
import { Spinner } from 'sos-common/js/components/Spinner/Spinner';

export interface StatsbidragSubmitButtonProps {
  canUserSend: boolean;
}

export interface StatsbidragSubmitButtonState {
  canSubmit: boolean;
  isModalOpen: boolean;
  isSending: boolean;
}

/**
 * Handles submit logic of the form. Prevents submitting if:
 *  - There are validation errors
 *  - The user has insufficient permissions
 */
export class StatsbidragSubmitButton extends React.Component<
  StatsbidragSubmitButtonProps,
  StatsbidragSubmitButtonState
> {
  constructor(props: StatsbidragSubmitButtonProps) {
    super(props);

    this.state = {
      canSubmit: true,
      isModalOpen: false,
      isSending: false,
    };
  }

  componentDidMount() {
    EventService.subscribe('form-is-valid', (e: CustomEvent) => {});
    EventService.subscribe(POST_ERROR, () => {
      this.setState({
        isSending: false,
      });
    });
  }

  submit = (e: React.MouseEvent) => {
    const { canUserSend } = this.props;
    const { canSubmit } = this.state;
    e.preventDefault();
    if (canUserSend && ValidationService.validateForm()) {
      this.setState(
        {
          isSending: true,
        },
        () => {
          EventService.fire(`form-submit-action`, { detail: SEND });
        }
      );
    } else {
      this.setState({
        canSubmit: false,
        isModalOpen: true,
      });
    }
  };

  openConfirm = () => {
    this.setState({
      isModalOpen: true,
    });
  };

  closeConfirm = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  getModalBodyText = () => {
    const { canUserSend } = this.props;
    const { canSubmit } = this.state;
    if (!canUserSend) return <p>Du har inte behörighet att skicka in ansökan.</p>;
    if (!canSubmit) return <p>Alla obligatoriska uppgifter måste besvaras innan ansökan kan skickas in.</p>;
  };

  getModalHeadingText = () => {
    const { canUserSend } = this.props;
    const { canSubmit } = this.state;
    if (!canUserSend) return <h2>Ej behörig</h2>;
    if (!canSubmit) return <h2>Otillräckliga uppgifter</h2>;
  };

  public render() {
    const { canUserSend } = this.props;
    const { canSubmit, isModalOpen, isSending } = this.state;

    return (
      <div className="stb-form-submitbtn-wrapper">
        <hr className="formdivider" />

        <button type="button" onClick={this.submit} disabled={!canUserSend || isSending} className="button">
          {isSending && (
            <div className="flex-center">
              <Spinner />
              <span>Skickar</span>
            </div>
          )}
          {!isSending && <span>Skicka in</span>}
        </button>

        <Dialog isOpen={isModalOpen} onRequestClose={this.closeConfirm}>
          <button type="button" onClick={this.closeConfirm} className="close">
            <Icon isAriaHidden={false} ariaLabel="Stäng" iconType="ic_close_white_24px" />
          </button>

          <div className="header">{this.getModalHeadingText()}</div>

          {this.getModalBodyText()}

          <div className="footer">
            <button type="button" className="button" onClick={this.closeConfirm}>
              Ok
            </button>
          </div>
        </Dialog>
      </div>
    );
  }
}
